/**
 * O vídeo de abertura — a apresentação em movimento de quem convida, antes da
 * primeira pergunta.
 *
 * Um `<iframe>` que carrega SOZINHO, sem clique de ninguém, é uma superfície
 * mais sensível que o botão da tela final (0007): lá o convidado escolhe
 * clicar; aqui o organizador escreve o endereço e todo mundo que abrir o
 * convite carrega o que ele escreveu. `enderecoDeVideoPermitido` é a MESMA
 * lista branca de hosts da CHECK `formulario_video_valido` (migração 0012) —
 * repetida aqui pelo motivo de `util/acao.ts` repetir a de `no_acao_valida`:
 * `src` de `<iframe>` não é texto, e a tela é trocável enquanto o banco não é.
 *
 * `null` aqui não é erro de rede nem "falta configuração" — é "isto não pode
 * acontecer" (a CHECK já recusou qualquer `video_url` fora da lista antes de
 * ele chegar ao banco). Pela decisão travada nº 8, esse degradado SAI DE VISTA
 * em vez de virar aviso: não há nada que o convidado possa fazer com "o vídeo
 * é inválido", e mostrar a frase seria assustar quem só veio confirmar
 * presença por um problema que não é dele.
 */

import { enderecoDeVideoPermitido } from '../../servicos/marca';

export type PropsDoVideo = {
  readonly url: string;
  /** O título do formulário, para o `<iframe>` ter um nome acessível único. */
  readonly titulo: string;
};

export function Video({ url, titulo }: PropsDoVideo) {
  const aceito = enderecoDeVideoPermitido(url);
  if (aceito === null) return null;

  return (
    <div className="convite__video-moldura">
      <iframe
        className="convite__video"
        src={aceito}
        title={`Vídeo de apresentação — ${titulo}`}
        loading="lazy"
        // Sem referrer, um player com restrição de domínio (recurso comum do
        // Vimeo e da Bunny Stream) para de tocar: o serviço não consegue
        // conferir de onde veio o pedido. Com o padrão do navegador, o
        // terceiro vê só a ORIGEM (o domínio do convite), nunca o caminho —
        // que poderia entregar o token do link nominal.
        referrerPolicy="strict-origin-when-cross-origin"
        // O mínimo para o player tocar e ir para tela cheia — nada além disso.
        // `allow-scripts` é o player em si: os três serviços da lista branca
        // são aplicações JS, e sem isto a tela ficaria em branco. `allow-same-origin`
        // é a origem DELE (youtube.com, vimeo.com, mediadelivery.net) — nunca
        // a nossa —, e alguns players nem inicializam sem ela. Nenhum dos
        // dois libera navegar a aba de fora nem abrir popup: um vídeo não
        // precisa de nenhum dos dois para tocar.
        sandbox="allow-scripts allow-same-origin"
        allow="encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
      />
    </div>
  );
}
